<template>
  <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>     
      <header-documento :locDocumento="locDocumento" :filtraTipiDocumento="filtraTipiDocumento" :trigger="trigger" :mostraParcheggio="mostraParcheggio" :forzaTipo="forzaTipo" @aggiornaDocumento="aggiornaDocumento"/> <!-- @update-tipo-documento="updateTipoDocumento" -->
      <body-documento :locDocumento="locDocumento" :trigger="trigger" :triggerST="triggerST" :popupSuCambioAcquisto="popupSuCambioAcquisto" :popupSuProdottoConFornitoreDiverso="popupSuProdottoConFornitoreDiverso" :mostraAggiungiProdotto="mostraAggiungiProdotto" @nuovaRiga="onNuovaRiga" @updateTotali="trigger++" @salvaDocumento="salvaDocumento" @mostraParcheggio="onMostraParcheggio" @move="spostaRiga"/>
      <footer-documento :locDocumento="locDocumento" :trigger="trigger" @updateTotali="triggerLocale++" @daSalvare="daSalvare = true"/>
      <v-card-actions>
        <v-row align="center" justify="end">
          <v-btn color="info" class="mt-3 mr-5" @click="stampaDocumento">Stampa documento</v-btn>
          <v-badge bordered color="error" icon="mdi-lock" overlap :value="ddtChiuso" class="mt-3 mr-5">
            <v-btn color="info" :disabled="chiudiDisabled" @click="chiudiDdt">Chiudi DDT</v-btn>
          </v-badge>
          <v-btn color="primary" class="mt-3 mr-5" :disabled="salvataggioInCorso || saveDisabled" @click="salvaDocumento">Salva documento</v-btn>
          <v-btn color="success" v-if="hasXml" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaXML">Salva e crea XML</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { downloadXml, getAnnoRiferimento } from '@/components/helpers.js'
  import errorService from '@/services/errorService'
  import { printed } from '@/helpers/printed.js'
  import xml7 from '@/services/xml7Service.js'
  import HeaderDocumento from './header.vue'
  import BodyDocumento from './bodyTableDdtFornitore.vue'
  import FooterDocumento from './footer.vue'
  // import prodotti from '@/services/prodottiService.js'
  import documenti from '@/services/documentiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import reporting from '@/services/reportingService.js'

  export default {
    components: {
      HeaderDocumento,
      BodyDocumento,
      FooterDocumento
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      readOnly: Boolean,
      filtraTipiDocumento: Array
    },
    data () {
      return {
        locDocumento: {model: '', generale: '', source: ''},
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        triggerST: 1,
        daSalvare: false,
        mostraParcheggio: false,
        ddtChiuso: false,
        forzaTipo: null,
        salvataggioInCorso: false,
        popupSuCambioAcquisto: false,
        popupSuProdottoConFornitoreDiverso: false,
        mostraAggiungiProdotto: false
      }
    },
    async created() {
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.popupSuCambioAcquisto = _.get(impostazioni, 'fornitori.popupSuCambioPrezzoAcquisto', false)
      this.popupSuProdottoConFornitoreDiverso = _.get(impostazioni, 'fornitori.popupSuProdottoConFornitoreDiverso', false)
      this.mostraAggiungiProdotto = _.get(impostazioni, 'fornitori.mostraAggiungiProdotto', false)
    },
    async mounted() {
      if (this.idDocumento) {
        this.locDocumento = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      } else {
        this.locDocumento = await documenti.getModello('xxx')
        this.completaAppoggio()
        this.locDocumento.data = new Date()
      }
      this.dialogDettaglioDocumento = this.showDialog
    },
    watch: {
      async showDialog(value) {
        if (value) {
          await this.refresh()
          setTimeout(async () => {
            const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDocumento = tipi.find(x => x.tipoDocumento === 'ddtFornitore')
            this.forzaTipo = tipoDocumento
          } , 300)
/*           this.dialogDettaglioDocumento = true
          this.locDocumento = await documenti.getDocumento(this.idDocumento) */
        }
      },
      trigger() {
        this.daSalvare = true
      }
/*       dialogDettaglioDocumento(value) {
        const rd = this.$store.getters.rightDrawer
        console.log('dialogDettaglioDocumento', rd)
        if (!value && rd) {
          this.dialogDettaglioDocumento = true
        }
      } */
/*       triggerLocale() {
        this.daSalvare = true
      }    */   
    },
    computed: {
      dialogTitle() {
        // TODO: Specificare in base al tipo scelto
        return this.idDocumento ? `Documento nr. ${this.idDocumento} ${this.solaLettura ? ' (sola lettura)' : ''}` : 'Nuovo documento'
      },
      colorModalita() {
        return this.nuovoDocumento ? 'indigo lighten-2' : 'indigo'
      },
      saveDisabled() {
        if (this.solaLettura) return true
        return this.trigger && this.triggerLocale && this.locDocumento && this.locDocumento.totali && this.locDocumento.totali.generale ? ((this.locDocumento.totali.generale.quantita === 0 && this.locDocumento.totali.generale.quantita2 === 0) || !this.daSalvare) : true
      },
      chiudiDisabled() {
        if (this.solaLettura) return true
        return !this.saveDisabled 
      },
      hasXml() {
        return this.trigger && this.triggerLocale && _.get(this.locDocumento, 'tipoDocumento.xml', false)
      },
      solaLettura() {
        return this.readOnly || this.ddtChiuso
      }
    },
    methods: {
      onMostraParcheggio(value) {
        this.mostraParcheggio = value
      },
      spostaRiga(da, a) {
        let righe = this.locDocumento.righe
        let daSpostare = JSON.parse(JSON.stringify(righe[da]))
        righe.splice(da, 1)
        if (a === -1) {
          righe.push(daSpostare)
        } else {
          righe.splice(a, 0, daSpostare)
        }
        this.trigger++
      },       
      async onNuovaRiga(riga) {
        this.locDocumento.righe.push(riga)
        this.trigger++
      },
      async refresh() {
        this.dialogDettaglioDocumento = true
        if (this.idDocumento) {
          this.locDocumento = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locDocumento = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locDocumento.data = new Date()
        }
        this.ddtChiuso = _.get(this.locDocumento, 'stato.codice', '') === 'chiuso'
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locDocumento
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },
      async aggiornaDocumento(documento) {
        Object.assign(this.locDocumento, documento)
        this.completaAppoggio()
        this.trigger++
      },
      async generaXmlItem(itemId) {
        const documento = await documenti.getDocumento(itemId)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },
      async chiudiDdt() {
        let itm = this.locDocumento
        itm.stato = { codice: 'chiuso', descrizione: 'Chiuso' }
        const result = await documenti.aggiornaDocumento(itm)
        this.ddtChiuso = true
      },  
      async stampaDocumento() {
        let item = this.locDocumento
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            errorService.onError(JSON.stringify(result.error))
          } else {
            await printed(item._id)
          }
        } catch {}
      },
      getPrezzoUnita(item, unita) {
        // ritorna il prezzo in base all'unità di misura selezionata
        // TODO: Gestire nel prodotto un array di valori con i corrispondenti fattori di conversione
        // Per adesso considero solo 2 prezzi (confezione/chilo e pezzo)
        const prezzoPezzo = _ .get(item, 'appoggio.prodotto.item.magazzino.prezzoAcquistoPezzo', 0)
        const prezzo = _.get(item, 'appoggio.prodotto.acquisto', 0)
        if (['pz', 'n'].includes(unita)) {
          return prezzoPezzo
        } else {
          return prezzo
        }
      },        
      async salvaDocumento() {
        try {
          this.salvataggioInCorso = true
          await this.$nextTick()
          let itm = this.locDocumento
          errorService.onInfo(JSON.stringify(itm))
          var result
          for (let r of itm.righe) {
            if (!_.get(r, 'ordine.prezzoUnitario')) {
              r.ordine = r.ordine || {}
              // r.ordine.prezzoUnitario = +parseFloat(r.valore.acquisto).toFixed(2)
              // r.ordine.prezzo = String(r.valore.acquisto)
              const pz = this.getPrezzoUnita(r, r.unitaMisura && r.unitaMisura.codice) || this.getPrezzoUnita(r, r.unitaMisura) || 0
              r.ordine.prezzoUnitario = +parseFloat(pz).toFixed(2)
              r.ordine.prezzo = String(pz)
            }
          }
          if (!itm.tipoDocumento.codice) {
            alert('Tipo documento non corretto! Contattare l\'assistenza')
            this.salvataggioInCorso = false
            return
          }           
          if (!itm._id) {
            const numeratore = itm.tipoDocumento.numeratore
            const annoRiferimento = getAnnoRiferimento(itm.data) // itm.data.getFullYear()
            const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
            itm._id = numero
            itm.codice = numero

            // itm = JSON.parse(JSON.stringify(this.locDocumento))
            await this.verificaAggiungiMovimenti(itm)
            this.spostaQuantitaSuConsegnato(itm)
            result = await documenti.creaDocumento(itm)

          } else {
            // itm = JSON.parse(JSON.stringify(this.locDocumento))
            await this.verificaModificaMovimenti(itm)
            this.spostaQuantitaSuConsegnato(itm)
            result = await documenti.aggiornaDocumento(itm)
            // Verifica se va aggiornato il movimento relativo
            // await this.verificaAggiungiMovimenti(result)
          }
          this.locDocumento = result
          this.completaAppoggio()
          this.trigger++
          this.triggerST++
          await this.$nextTick()
          this.daSalvare = false
          this.salvataggioInCorso = false
          return result
        } catch (error) {
          errorService.onError(error, 'editDDTFornitore.salvaDocumento')
          this.salvataggioInCorso = false
        }        
      },
      async salvaXML() {
        // verificare se c'è qualcosa da salvare, altrimenti evitare
        // const doc = await this.salvaDocumento()
        if (this.daSalvare) {
          // await this.salvaDocumento()
        }
        await this.generaXmlItem(this.locDocumento._id)
      },
      closeDialogDocumento() {
        this.dialogDettaglioDocumento = false
        this.locDocumento = { model: '', generale: '', source: '', tipoDocumento: { codice: null } }
        this.$emit('refresh')
      },
      async verificaAggiungiMovimenti(documento) {
        const movimentiSalvati = await movimenti.getMovimentiPerRiferimento('documento', documento._id)
        // Verificare altri tipi di documento
        const arProdotti = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('xxx')
        let numErrori = 0
        for (const p of arProdotti.filter(x => x.quantita > 0 || x.quantita2 > 0)) { // I movimenti vengono creati solo per le righe dove è presente la quantità.
          if (p.scalaTaglie) {
            for (const pp of p.scalaTaglie.elencoProdotti2) { // Le quantità inserite nella DDT
              const pdb = p.appoggio.prodotto.item
              const listino = _.get(this.locDocumento, 'appoggio.clifor.amministrativi.listino.codice', 'L1')
              let movimento = JSON.parse(JSON.stringify(modello))       				   
              movimento.data = documento.data || new Date()
              movimento.magazzino = documento.magazzino || this.$store.getters['magazzini/codiceMagazzino']
              movimento.prodotto = {
                codice: pp.id, // p.prodotto.codice,
                lotti: [],
                um: p.unitaMisura,
                quantita: +parseFloat(pp.quantita).toFixed(2),
                prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0) || _.get(pdb, 'magazzino.prezzoAcquisto', 0),
                prezzoUnitario: (_.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0)) || _.get(pdb, 'prezzo.' + listino + '.base'),
                listino: _.get(p, 'valore.listino', null)				  
              }
              // Poichè è una ddt fornitore, considero sempre il prezzo di acquisto !!!
              const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) 
              movimento.prodotto.prezzo = + (pzUn || movimento.prodotto.prezzoAcquisto).toFixed(2)
              // movimento.prodotto.prezzo = +(movimento.prodotto.quantita * movimento.prodotto.prezzoUnitario).toFixed(2)
              movimento.quantita = +parseFloat(pp.quantita).toFixed(2)
              // let vv = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
              // movimento.valore = +((vv / (p.quantita || p.quantita2)) * pp.quantita).toFixed(2)
              movimento.valore = +(pzUn * pp.quantita).toFixed(2)
              movimento.prezzo = movimento.valore
              movimento.causale = documento.tipoDocumento.causale
              movimento.anagrafica = {
                cliente: '',
                fornitore: documento.anagrafica.fornitore
              }
              movimento.riferimento = {
                tipo: 'documento',
                id: documento.codice,
                data: documento.data
              }
              if (pdb.custom) {
                movimento.custom = pdb.custom
              }
              if (!await magazzino.creaMovimenti(movimento)) {
                numErrori++
              }
              if (documento.tipoDocumento.secondoMagazzino) {
                movimento.causale = documento.tipoDocumento.causale2
                movimento.magazzino = documento.magazzino2
                if (!await magazzino.creaMovimenti(movimento)) {
                  numErrori++
                }            
              }
            }
          } else {
          // for (const p of prodotti) {
            const pdb = p.appoggio.prodotto.item
            const listino = _.get(this.locDocumento, 'appoggio.clifor.amministrativi.listino.codice', 'L1')
            let movimento = JSON.parse(JSON.stringify(modello))
            // TODO: Nel caso di modifica andrebbe aggiunto un secondo ad ogni riga, altrimenti la data è identica su tutte le righe. 
            //       C'è rnd finale, ma con tante righe è possible che ne generi due uguali
            movimento.data = documento.data || new Date()
            movimento.magazzino = documento.magazzino || this.$store.getters['magazzini/codiceMagazzino']
  /*           let qtaAnagrafica = +parseFloat(p.quantita).toFixed(2)
            let qtaVendita = qtaAnagrafica
            if (p.custom && p.custom.tabacchi) {
              // TODO:Generalizzare mettendo il fattore di conversione in magazzino
              qtaVendita = +parseFloat(p.quantita * p.custom.tabacchi.pesoConfezione).toFixed(2)
            } */
            movimento.prodotto = {
              codice: p.prodotto.codice,
              lotti: [],
              um: p.unitaMisura,
              quantita: +parseFloat(p.quantita).toFixed(2), // qtaVendita
              prezzoUnitario: (_.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0)) || _.get(pdb, 'prezzo.' + listino + '.base'),
              prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0) || _.get(pdb, 'magazzino.prezzoAcquisto', 0)
            }
            movimento.quantita = +parseFloat(p.quantita).toFixed(2) // qtaVendita
            
            // Poichè è una ddt fornitore, considero sempre il prezzo di acquisto !!!
            const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) // Verificare eventuali sconti
            movimento.valore = +parseFloat(movimento.quantita * pzUn).toFixed(2) // qtaAnagrafica
            movimento.prezzo = movimento.valore
            movimento.prodotto.prezzo = + (pzUn || movimento.prodotto.prezzoAcquisto).toFixed(2)
            movimento.causale = documento.tipoDocumento.causale
            
            movimento.anagrafica = {
              cliente: '',
              fornitore: documento.anagrafica.fornitore
            }
            movimento.riferimento = {
              tipo: 'documento',
              id: documento.codice,
              data: documento.data,
              riga: p.codice
            }
            if (pdb.custom) {
              movimento.custom = pdb.custom
            }
            if (!await magazzino.creaMovimenti(movimento)) {
              console.log('errore creazione movimento', movimento)
              numErrori++
            }
          }
        }
        // Ulteriore verifica sui prodotti con qta = 0. Verifico che i vecchi movimenti siano stati creati (non dovrebbe servire...)
        // TODO: Verificare la necessità. Aggiunto per correggere eventuali problemi di creazione movimenti su salvataggio
        // Andrebbe verificata anche la quantità nel caso non fosse coerente tra movimenti e documento

        // TODO: Verificare ### 19.04.2024 Tolta. Non funziona se carico più volte lo stesso prodotto !!
        const daElaborare = [] // arProdotti.filter(x => x.quantita === 0 && x.quantita2 === 0 && _.get(x, 'ordine.consegnato', 0) > 0)
        let k = 0
        for (const p of daElaborare) {
          if (p.scalaTaglie) {
            for (const pp of p.scalaTaglie.elencoProdotti2) {
              const mov = movimentiSalvati.find(x => x.prodotto.codice === pp.id)
              let qtaMov = 0
              if (mov) {
                qtaMov = mov.quantita
              }
              // console.log(++k, p.prodotto.codice)
              let cons = p.scalaTaglie.elencoProdottiConsegnati.find(x => x.id === pp.id)
              let qtaCons = cons ? _.get(cons, 'ordine.consegnato', 0) : 0
              if (!mov || qtaMov !== qtaCons) {
                let movimento = JSON.parse(JSON.stringify(modello))
                movimento.data = documento.data || new Date()
                movimento.magazzino = documento.magazzino || this.$store.getters['magazzini/codiceMagazzino']
                let qta = +parseFloat(qtaCons).toFixed(2)
                qta -= qtaMov // tolgo l'eventuale quantità già caricata
                movimento.prodotto = {
                  codice: pp.id,
                  lotti: [],
                  um: p.unitaMisura,
                  quantita: qta // qtaVendita
                }
                movimento.quantita = qta // qtaVendita
                // const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) // Verificare eventuali sconti
                // movimento.valore = +parseFloat(movimento.quantita * pzUn).toFixed(2) // qtaAnagrafica
                let vv = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
                movimento.valore = +((vv / p.quantita) * pp.quantita).toFixed(2)
                movimento.causale = documento.tipoDocumento.causale
                movimento.anagrafica = {
                  cliente: '',
                  fornitore: documento.anagrafica.fornitore
                }
                movimento.riferimento = {
                  tipo: 'documento',
                  id: documento.codice,
                  data: documento.data
                  // riga: p.codice
                }
                const result = await magazzino.creaMovimenti(movimento)
                if (!result) {
                  console.log('errore !')
                  numErrori++
                } else {
                  console.log('creato', k, result._id)
                }
              }
            }
          } else {
            const mov = movimentiSalvati.find(x => x.prodotto.codice === p.prodotto.codice)
            let qtaMov = 0
            if (mov) {
              qtaMov = mov.quantita
            }
            // console.log(++k, p.prodotto.codice)
            if (!mov || qtaMov !== _.get(p, 'ordine.consegnato', 0)) {
              // console.log('movimento non trovato per prodotto:', k, p.prodotto.codice)
              let movimento = JSON.parse(JSON.stringify(modello))
              movimento.data = documento.data || new Date()
              movimento.magazzino = documento.magazzino || this.$store.getters['magazzini/codiceMagazzino']
              let qta = +parseFloat(_.get(p, 'ordine.consegnato', 0)).toFixed(2)
              qta -= qtaMov // tolgo l'eventuale quantità già caricata
              movimento.prodotto = {
                codice: p.prodotto.codice,
                lotti: [],
                um: p.unitaMisura,
                quantita: qta // qtaVendita
              }
              movimento.quantita = qta // qtaVendita
              const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) // Verificare eventuali sconti
              movimento.valore = +parseFloat(movimento.quantita * pzUn).toFixed(2) // qtaAnagrafica
              movimento.causale = documento.tipoDocumento.causale
              movimento.anagrafica = {
                cliente: '',
                fornitore: documento.anagrafica.fornitore
              }
              movimento.riferimento = {
                tipo: 'documento',
                id: documento.codice,
                data: documento.data,
                riga: p.codice
              }
              const result = await magazzino.creaMovimenti(movimento)
              if (!result) {
                console.log('errore !')
                numErrori++
              } else {
                console.log('creato', k, result._id)
              }
            }
          }
          // TODO: Verificare per scala taglie
 
        }
        // Verifica quantità < 0 e cancella i movimenti relativi
        const daCancellare = arProdotti.filter(x => x.quantita < 0 || x.quantita2 < 0)
        k = 0
        for (const p of daCancellare) {
          if (p.scalaTaglie) {
            for (const pp of p.scalaTaglie.elencoProdotti2) {
              let mov = movimentiSalvati.find(x => x.prodotto.codice === pp.id)
              let qtaMov = 0
              if (mov) {
                qtaMov = mov.quantita
              }
              if (Math.abs(pp.quantita) >= qtaMov) {
                await movimenti.cancellaMovimento(mov._id)
              } else {
                qtaMov = qtaMov + pp.quantita
                mov.quantita = qtaMov
                mov.valore = mov.quantita * _.get(mov, 'prodotto.prezzoUnitario', 0)
                _.set(mov, 'prodotto.prezzo', mov.valore)
                await movimenti.aggiornaMovimento(mov)
              }
              const mag = _.get(documento, 'tipoDocumento.magazzino', 'mag01')
              await prodotti.aggiornaDeltaGiacenza(pp.id, mag, pp.quantita)
            }
          } 
/*           else {
            const mov = movimentiSalvati.find(x => x.prodotto.codice === p.prodotto.codice)
            let qtaMov = 0
            if (mov) {
              qtaMov = mov.quantita
            }
            // console.log(++k, p.prodotto.codice)
            if (!mov || qtaMov !== _.get(p, 'ordine.consegnato', 0)) {
              // console.log('movimento non trovato per prodotto:', k, p.prodotto.codice)
              let movimento = JSON.parse(JSON.stringify(modello))
              movimento.data = documento.data || new Date()
              movimento.magazzino = documento.magazzino || this.$store.getters['magazzini/codiceMagazzino']
              let qta = +parseFloat(_.get(p, 'ordine.consegnato', 0)).toFixed(2)
              qta -= qtaMov // tolgo l'eventuale quantità già caricata
              movimento.prodotto = {
                codice: p.prodotto.codice,
                lotti: [],
                um: p.unitaMisura,
                quantita: qta // qtaVendita
              }
              movimento.quantita = qta // qtaVendita
              const pzUn = +parseFloat((p.ordine && p.ordine.prezzoUnitario) || p.valore.acquisto).toFixed(2) // Verificare eventuali sconti
              movimento.valore = +parseFloat(movimento.quantita * pzUn).toFixed(2) // qtaAnagrafica
              movimento.causale = documento.tipoDocumento.causale
              movimento.anagrafica = {
                cliente: '',
                fornitore: documento.anagrafica.fornitore
              }
              movimento.riferimento = {
                tipo: 'documento',
                id: documento.codice,
                data: documento.data,
                riga: p.codice
              }
              const result = await magazzino.creaMovimenti(movimento)
              if (!result) {
                console.log('errore !')
                numErrori++
              } else {
                console.log('creato', k, result._id)
              }
            }
          } */
        }        
      },
      async verificaModificaMovimenti(documento) {
        // Non si può cancellare per riferimento perchè vengono ricreate solo le quantità presenti nella colonna Quantità e non in quella Consegnato
        // await magazzino.cancellaPerRiferimento('documento', documento.codice, documento.data)
        await this.verificaAggiungiMovimenti(documento)
      },   
      spostaQuantitaSuConsegnato(documento) {
        for (let r of documento.righe.filter(x => x.quantita > 0 || x.quantita2 > 0)) {
          const qta = +parseFloat(r.quantita || r.quantita2 || 0).toFixed(2)
          r.ordine = r.ordine || {}
          r.ordine.consegnato = +parseFloat(((r.ordine.consegnato) || 0) + qta).toFixed(2)
          r.ordine.consegna = r.ordine.consegna || []
          r.ordine.consegna.push({
            quantita: r.quantita,
            data: new Date(),
            prezzo: r.ordine.prezzo,
            prezzoUnitario: r.ordine.prezzoUnitario,
            sconto1: r.ordine.sconto1,
            sconto2: r.ordine.sconto2,
            sconto3: r.ordine.sconto3,
            sconto4: r.ordine.sconto4
          })
          r.quantita = 0
          r.quantita2 = 0
          r.ordine.prezzo = ''
          r.ordine.sconto1 = ''
          r.ordine.sconto2 = ''
          r.ordine.sconto3 = ''
          r.ordine.sconto4 = ''
          if (r.usaScalaTaglie) {
            r.scalaTaglie.elencoProdottiConsegnati = r.scalaTaglie.elencoProdottiConsegnati || []
            for (let p of r.scalaTaglie.elencoProdotti2) {
              let pc = r.scalaTaglie.elencoProdottiConsegnati.find(x => x.id === p.id)
              if (pc) {
                pc.quantita = pc.quantita + p.quantita
              } else {
                r.scalaTaglie.elencoProdottiConsegnati.push(p)
              }
            }
            while(r.scalaTaglie.elencoProdotti2.length > 0) { r.scalaTaglie.elencoProdotti2.pop() } // Altrimenti vue non aggiorna 
          }
          if (r.ordine.prezzoUnitario !== r.valore.acquisto) {
            r.valore.acquisto = r.ordine.prezzoUnitario
          }
        }
        for (let r of documento.righe.filter(x => x.quantita < 0 || x.quantita2 < 0)) {
          let qta = +parseFloat(r.quantita || r.quantita2 || 0).toFixed(2)
          r.ordine = r.ordine || {}
          r.ordine.consegnato = +parseFloat(((r.ordine.consegnato) || 0) + qta).toFixed(2)
          r.ordine.consegna = r.ordine.consegna || []
          r.ordine.consegna.push({
            quantita: r.quantita,
            data: new Date(),
            prezzo: r.ordine.prezzo,
            prezzoUnitario: r.ordine.prezzoUnitario,
            sconto1: r.ordine.sconto1,
            sconto2: r.ordine.sconto2,
            sconto3: r.ordine.sconto3,
            sconto4: r.ordine.sconto4
          })
          r.quantita = 0
          r.quantita2 = 0
          r.ordine.prezzo = ''
          r.ordine.sconto1 = ''
          r.ordine.sconto2 = ''
          r.ordine.sconto3 = ''
          r.ordine.sconto4 = ''
          if (r.usaScalaTaglie) {
            r.scalaTaglie.elencoProdottiConsegnati = r.scalaTaglie.elencoProdottiConsegnati || []
            for (let p of r.scalaTaglie.elencoProdotti2) {
              let pc = r.scalaTaglie.elencoProdottiConsegnati.find(x => x.id === p.id)
              if (pc) {
                pc.quantita = pc.quantita + p.quantita
              } else {
                r.scalaTaglie.elencoProdottiConsegnati.push(p)
              }
            }
            while(r.scalaTaglie.elencoProdotti2.length > 0) { r.scalaTaglie.elencoProdotti2.pop() } // Altrimenti vue non aggiorna 
          }
          if (r.ordine.prezzoUnitario !== r.valore.acquisto) {
            r.valore.acquisto = r.ordine.prezzoUnitario
          }
        }        
      }
    }
  }
</script>
